//跳转外链-用户端首页
export const web_zc_home = 'https://www.emof.cn'

export const service_phone = '400-999-6541'

export const menus = [
    { value: 1, role: [1,2], label: '内容管理', icon: 'icon-xiangmu', page: '/web/admin/card/classify' },
    { value: 0, role: [1,2,3], label: '员工管理', icon: 'icon-renyuan', page: '/web/admin/member' },
    { value: 3, role: [1,2,3], label: '部门管理', icon: 'icon-bumenguanli-1', page: '/web/admin/dept' },
    // { value: 2, role: [1,2,3], label: '消息中心', icon: 'icon-renwu', page: '/web/admin/message' },
    { value: 4, role: [1,2,3], label: '帮助中心', icon: 'icon-bangzhuzhongxin', page: '/web/help' },
]

export const basic_classify = [
    {id:1,type_name:'机构介绍'},
    {id:2,type_name:'荣誉证书'},
    {id:3,type_name:'服务项目'},
    {id:4,type_name:'品牌活动'},
]
